"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CXTupleToDefaultPreferencesQueryResolver = exports.CXTupleToDefaultPreferencesQueryResolverDevo = void 0;
const offline_query_resolver_1 = __importDefault(require("./offline-query-resolver"));
const i18nPreferencesACSConfig_1 = require("@amzn/i18n-preferences-acsconfig-type-script-client/dist/i18nPreferencesACSConfig");
const i18n_configuration_provider_1 = require("@amzn/i18n.configuration-provider");
const documents_json_1 = require("@amzn/i18n-preferences-acsconfig/dist/acs_I18nPreferencesACSConfig/documents.json");
const queries_json_1 = require("@amzn/i18n-preferences-acsconfig/dist/acs_I18nPreferencesACSConfig/queries.json");
const hierarchical_queries_json_1 = require("@amzn/i18n-preferences-acsconfig/dist/devo/acs_I18nPreferencesACSConfig/hierarchical_queries.json");
const documents_json_2 = require("@amzn/i18n-preferences-acsconfig/dist/devo/acs_I18nPreferencesACSConfig/documents.json");
const queries_json_2 = require("@amzn/i18n-preferences-acsconfig/dist/devo/acs_I18nPreferencesACSConfig/queries.json");
const hierarchical_queries_json_2 = require("@amzn/i18n-preferences-acsconfig/dist/acs_I18nPreferencesACSConfig/hierarchical_queries.json");
const OfflineClientSettings_1 = __importDefault(require("@amzn/amazon-config-store-type-script-offline-adapter/dist/OfflineClientSettings"));
const ClientStage_1 = __importDefault(require("@amzn/amazon-config-store-model-tscommon/dist/utils/ClientStage"));
/**
 * Resolves CXTuple Default Preferences queries using the I18nPreferencesACSConfig feature
 * (https://console.harmony.a2z.com/acs-web-editor/features/I18nPreferencesACSConfig).
 */
class CXTupleToDefaultPreferencesQueryResolver extends offline_query_resolver_1.default {
    resolve(attributeName, args) {
        this.validate(attributeName, args);
        return this.doResolve(attributeName, args);
    }
    doResolve(attributeName, args) {
        const context = this.createACSInput(args);
        const configBuilder = new i18n_configuration_provider_1.I18nConfiguration.Builder();
        switch (attributeName) {
            case i18n_configuration_provider_1.CXTupleToDefaultPreferences.DEFAULT_CURRENCY:
                const defaultCurrency = this.getAcsClient().getDefaultCurrency(context);
                configBuilder.addConfiguration(i18n_configuration_provider_1.CXTupleToDefaultPreferencesResult.DEFAULT_CURRENCY, defaultCurrency);
                break;
            case i18n_configuration_provider_1.CXTupleToDefaultPreferences.DEFAULT_LANGUAGE:
                const defaultLanguage = this.getAcsClient().getDefaultLanguage(context);
                configBuilder.addConfiguration(i18n_configuration_provider_1.CXTupleToDefaultPreferencesResult.DEFAULT_LANGUAGE, defaultLanguage);
                break;
            default:
                throw new Error(`Attribute name ${attributeName} is not defined for feature ${attributeName.getConfigType()}`);
        }
        return configBuilder.build();
    }
    createACSInput(args) {
        const cxFamily = args.cxFamily;
        const cxId = args.cxId;
        // CXProgram is an optional field that defaults to an empty list
        const cxProgram = !(0, i18n_configuration_provider_1.isNullOrUndefined)(args.cxProgram) && args.cxProgram.length > 0 ?
            args.cxProgram : CXTupleToDefaultPreferencesQueryResolver.EMPTY_CX_PROGRAM_LIST;
        if ((0, i18n_configuration_provider_1.isNullOrUndefined)(cxFamily)) {
            throw new Error('Missing required input CXFamily');
        }
        if ((0, i18n_configuration_provider_1.isNullOrUndefined)(cxId)) {
            throw new Error('Missing required input CXId');
        }
        return new i18nPreferencesACSConfig_1.I18nPreferencesACSConfigContext(cxFamily, cxId, cxProgram);
    }
    getAcsClient() {
        return super.acsClient;
    }
    getTypeSafeClientProvider() {
        return new i18nPreferencesACSConfig_1.I18nPreferencesACSConfigClientProvider();
    }
    getOfflineConfigFiles() {
        return {
            documents: documents_json_1.documents,
            exactQueries: queries_json_1.queries,
            hierarchicalFallbackQueries: hierarchical_queries_json_1.queries
        };
    }
    getTargetConfigType() {
        return CXTupleToDefaultPreferencesQueryResolver.CONFIG_TYPE;
    }
    getValidationErrorMessage() {
        return `CXTuple Default Preferences can only be resolved for configType ${CXTupleToDefaultPreferencesQueryResolver.CONFIG_TYPE}`;
    }
}
exports.CXTupleToDefaultPreferencesQueryResolver = CXTupleToDefaultPreferencesQueryResolver;
CXTupleToDefaultPreferencesQueryResolver.CONFIG_TYPE = i18n_configuration_provider_1.ConfigType.CX_TUPLE_TO_DEFAULT_PREFERENCES;
CXTupleToDefaultPreferencesQueryResolver.EMPTY_CX_PROGRAM_LIST = "[]";
class CXTupleToDefaultPreferencesQueryResolverDevo extends CXTupleToDefaultPreferencesQueryResolver {
    getOfflineClientSettings() {
        return new OfflineClientSettings_1.default({
            stage: ClientStage_1.default.DEVO
        });
    }
    getOfflineConfigFiles() {
        return {
            documents: documents_json_2.documents,
            exactQueries: queries_json_2.queries,
            hierarchicalFallbackQueries: hierarchical_queries_json_2.queries
        };
    }
}
exports.CXTupleToDefaultPreferencesQueryResolverDevo = CXTupleToDefaultPreferencesQueryResolverDevo;
//# sourceMappingURL=cx-tuple-to-default-preferences-query-resolver.js.map